import { CONSULTATION_METHODS } from './consultation-methods.model';
import { TRANSACTION_NAMES } from './transaction-names.model';
/** Position */
export class Position {
    /** orderPosition */
    public orderPosition?: string;
    /** articlesPerPosition */
    public articlesPerPosition?: number;
    /** articleNumber */
    public articleNumber?: string;
    /** articleName */
    public articleName?: string;
    /** simNumber */
    public simNumber?: string;
    /** msisdn */
    public msisdn?: string;
    /** imageLink */
    public imageLink?: string;
    /** deviceName */
    public deviceName?: string;
    /** date */
    public date?: string;
    /** quantity */
    public quantity?: number;
    /** toGrossPrice */
    public toGrossPrice?: string;
    /** size */
    public size?: string;
    /** color */
    public color?: string;
    /** outStock */
    public outStock?: string;
    /** availabilityDate */
    public availabilityDate?: string;
    /** transactionName */
    public transactionName?: TRANSACTION_NAMES;
    /** forwardToAgent */
    public forwardToAgent?: CONSULTATION_METHODS;
    /** imei */
    public imei?: string;
    /** toArticleNumber */
    public toArticleNumber?: string;
    /** returnReasonCode */
    public returnReasonCode?: number;
    /** returnReasonText */
    public returnReasonText?: string;
    /** returnFreeText */
    public returnFreeText?: string;
    /** returnsEntitled */
    public returnsEntitled?: ReturnsEntitled;
    /** orderId */
    public orderId?: string;
    /** kit */
    public kit?: string;
    /** previousTransactions */
    public previousTransactions?: PerviousTransaction[];
    /** lastAcceptedDate */
    public lastAcceptedDate?: string;
    /** scheduledDeliveryDate */
    public scheduledDeliveryDate?: boolean;
    /** deliveryDate */
    public deliveryDate?: string;
    /** secondDeliveryAllowed */
    public secondDeliveryAllowed?: boolean;
    /** productGroup */
    public productGroup?: string;
    /** toImageLink */
    public toImageLink?: string;
    /** esims */
    public esims?: Array<EsimModel>;
    /** toSimFormat */
    public toSimFormat?: string;
    /** simFormat */
    public simFormat?: string;
    /** tariffName */
    public tariffName?: string;
    /** positionClassification */
    public positionClassification?: PositionClassification;
}
/** PerviousTransaction */
export class PerviousTransaction {
    /** transactionName */
    public transactionName: TRANSACTION_NAMES;
    /** timestamp */
    public timestamp: string;
    /** forwardToAgent */
    public forwardToAgent: CONSULTATION_METHODS;
    /** returnReasonCode */
    public returnReasonCode?: number;
    /** returnReasonText */
    public returnReasonText?: string;
    /** returnFreeText */
    public returnFreeText?: string;
    /** quantity */
    public quantity?: number;
}
/** PositionStatus */
export enum PositionStatus {

    ADD,
    DELETE,
}
/** PositionClassification  */
export enum PositionClassification {
    isSim = 'isSim',
    isHardware = 'isHardware',
    isEsim = 'isEsim',
    isAccessories = 'isAccessories',
}
/** ReturnsEntitled */
export enum ReturnsEntitled {
    W = 'W',
    Z = 'Z',
    N = 'N',
}
/** EsimModel */
export class EsimModel {
    /** serialNumber */
    public serialNumber: string;
    /** simStatus */
    public simStatus: string;
    /** ultraCardSlot */
    public ultraCardSlot?: number;
    /** eid */
    public eid?: string;
    /** activationCode */
    public activationCode: string;
    /** confirmationCode */
    public confirmationCode: string;
    /** oldSim */
    public oldSim?: string;
    /** esimStatus */
    public esimStatus?: string;
    /** isInstalled */
    public isInstalled?: boolean;
    /** positionClassification */
    public positionClassification?: PositionClassification;
}
/** PositionDataAsArray */
export interface PositionDataAsArray {
    /** hardwares */
    hardwares: Position[];
    /** sims */
    sims: Position[];
    /** accessories */
    accessories: Position[];
}
/** PositionDataAsMap */
export interface PositionDataAsMap {
    /** hardwares */
    hardwares: { [key: string]: Position[]; };
    /** sims */
    sims: { [key: string]: Position[]; };
    /** accessories */
    accessories: { [key: string]: Position[]; };
}
